import * as React from "react"
import {Box} from "@mui/material";
import {translateCountryName} from "@ui-seeker/utils";

import {LabelCountry} from "@components";


export default function retailerColumn() {
	return [{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: value => translateCountryName(value)
		}
	}, {
		name: "retailer", label: "Retailer",
		options: {
			customBodyRowRenderLite: (value, { country, siteURL }) => <Box display="flex" gap={1} pl={2}>
				<LabelCountry country={country} label={value} url={siteURL} /> 
			</Box>
		}
	}]
}